const Mutations = Object.freeze({
	SET_SELECTED_FORM:
		'inventoryFormModule/formBuilder/formDetails/SET_SELECTEDFORM',
	SET_ENTITIES: 'inventoryFormModule/formBuilder/formDetails/SET_ENTITIES',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/formBuilder/formDetails/CLEAR',
	LOAD: 'inventoryFormModule/formBuilder/formDetails/LOAD',
	INSERT_INVENTORYFORMS:
		'inventoryFormModule/formBuilder/formDetails/INSERT_INVENTORYFORMS',
	UPDATE_INVENTORYFORMS:
		'inventoryFormModule/formBuilder/formDetails/UPDATE_INVENTORYFORMS',
});

export const Getters = Object.freeze({
	SELECTEDFORM: 'inventoryFormModule/formBuilder/formDetails/SELECTEDFORM',
	ENTITIES: 'inventoryFormModule/formBuilder/formDetails/ENTITIES',
});

import dataService from '../../../../../../services/data/inventoryFormService';
import { GeneralActions, InventoryFormActions } from '../../../../../actions';
export default {
	state: {
		entities: [],
		selectedInventoryForm: null,
	},
	mutations: {
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_SELECTED_FORM](state, item) {
			state.selectedInventoryForm = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_SELECTED_FORM, null);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, formId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let promises = [
					dataService.getEntities().then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
					}),
				];
				if (formId)
					promises.push(
						dataService.getFormById(formId).then((resp) => {
							commit(Mutations.SET_SELECTED_FORM, resp.data);
						})
					);

				Promise.all(promises)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.INSERT_INVENTORYFORMS]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertForm(item)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_FORM, resp.data);
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_INVENTORYFORMS]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateForm(item)
					.then(() => {
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.SELECTEDFORM]: (state) => {
			return JSON.parse(JSON.stringify(state.selectedInventoryForm));
		},
		[Getters.ENTITIES]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.entities.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
	},
};
